//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { ActionStatusOptions } from '../../../action-status/action-status.controller'
import { Enums } from '../../../../../models/common'
import { IAlarmConfigurable, ICopyable, IReferenceType } from '../../../../../models/util/interfaces'
import { OpAlarmDef, OpAlarmDefGroup } from '../../../../../models/core'
import { DataProvider } from '../../../../../helpers'
import { ColumnModel } from '../../../../api/api.models'

// #region GoAlarmDef

export class GoAlarmDef
    implements ICopyable<GoAlarmDef>
{
    public isTemplate: boolean
    public visible: boolean // Do zgodności z DX, to nie jest to samo co OpAlarmDef.visible !!!

    private opAlarmDef: OpAlarmDef
    private originalGroups: OpAlarmDefGroup[]

    public constructor(alarmDef: OpAlarmDef) {
        if (alarmDef != null) {
            this.alarmDef = alarmDef

            this.visible = true
        }
    }

    public get alarmDef(): OpAlarmDef { return this.opAlarmDef }
    public set alarmDef(value: OpAlarmDef) {
        this.opAlarmDef = value

        this.originalGroups = this.opAlarmDef != null && this.opAlarmDef.currentAlarmDefGroups != null
            ? this.opAlarmDef.currentAlarmDefGroups.map((group: OpAlarmDefGroup) => group.clone(true, true, true, true))
            : []

    }

    // #region OpAlarmDef Properties

    public get idAlarmDef(): number { return this.opAlarmDef.idAlarmDef }
    public set idAlarmDef(value: number) { this.opAlarmDef.idAlarmDef = value }

    public get name(): string { return this.opAlarmDef.name }
    public set name(value: string) { this.opAlarmDef.name = value }

    public get serialNbr(): number { return this.opAlarmDef.serialNbr }
    public set serialNbr(value: number) { this.opAlarmDef.serialNbr = value }

    public get idMeter(): number { return this.opAlarmDef.idMeter }
    public set idMeter(value: number) { this.opAlarmDef.idMeter = value }

    public get idLocation(): number { return this.opAlarmDef.idLocation }
    public set idLocation(value: number) { this.opAlarmDef.idLocation = value }

    public get idAlarmType(): number { return this.opAlarmDef.idAlarmType }
    public set idAlarmType(value: number) { this.opAlarmDef.idAlarmType = value }

    public get idDataTypeAlarm(): number { return this.opAlarmDef.idDataTypeAlarm }
    public set idDataTypeAlarm(value: number) { this.opAlarmDef.idDataTypeAlarm = value }

    public get idDataTypeConfig(): number { return this.opAlarmDef.idDataTypeConfig }
    public set idDataTypeConfig(value: number) { this.opAlarmDef.idDataTypeConfig = value }

    public get systemAlarmValue(): any { return this.opAlarmDef.systemAlarmValue }
    public set systemAlarmValue(value: any) { this.opAlarmDef.systemAlarmValue = value }

    public get isEnabled(): boolean { return this.opAlarmDef.isEnabled }
    public set isEnabled(value: boolean) { this.opAlarmDef.isEnabled = value }

    public get idAlarmText(): number { return this.opAlarmDef.idAlarmText }
    public set idAlarmText(value: number) { this.opAlarmDef.idAlarmText = value }

    public get idAlarmData(): number { return this.opAlarmDef.idAlarmData }
    public set idAlarmData(value: number) { this.opAlarmDef.idAlarmData = value }

    public get checkLastAlarm(): boolean { return this.opAlarmDef.checkLastAlarm }
    public set checkLastAlarm(value: boolean) { this.opAlarmDef.checkLastAlarm = value }

    public get suspensionTime(): number { return this.opAlarmDef.suspensionTime }
    public set suspensionTime(value: number) { this.opAlarmDef.suspensionTime = value }

    public get isConfirmable(): boolean { return this.opAlarmDef.isConfirmable }
    public set isConfirmable(value: boolean) { this.opAlarmDef.isConfirmable = value }

    public get indexNbr(): number { return this.opAlarmDef.indexNbr }
    public set indexNbr(value: number) { this.opAlarmDef.indexNbr = value }

    public get opState(): Enums.OpChangeState { return this.opAlarmDef.opState }
    public set opState(value: Enums.OpChangeState) { this.opAlarmDef.opState = value }

    // #endregion

    public toOpAlarmDef(): OpAlarmDef {
        if (this.opAlarmDef == null) {
            return null
        }

        this.originalGroups = this.originalGroups || []
        this.opAlarmDef.currentAlarmDefGroups = this.opAlarmDef.currentAlarmDefGroups || []

        this.originalGroups.forEach((originalGroup: OpAlarmDefGroup) => {
            let currentGroup: OpAlarmDefGroup = _.find(
                this.opAlarmDef.currentAlarmDefGroups,
                (group: OpAlarmDefGroup) => originalGroup.idAlarmGroup == group.idAlarmGroup && originalGroup.idTransmissionType == group.idTransmissionType
            )

            if (currentGroup == null) {
                currentGroup = new OpAlarmDefGroup(null)
                currentGroup.idAlarmDef = this.opAlarmDef.idAlarmDef
                currentGroup.idAlarmGroup = originalGroup.idAlarmGroup
                currentGroup.idTransmissionType = originalGroup.idTransmissionType
                currentGroup.opState = Enums.OpChangeState.Delete

                this.opAlarmDef.currentAlarmDefGroups.push(currentGroup)
            }
        })

        return this.opAlarmDef
    }

    public copy(sourceObject: GoAlarmDef, includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): void {
        if (sourceObject == null) { return }


        if (sourceObject.opAlarmDef != null) {
            this.opAlarmDef = sourceObject.opAlarmDef.clone(includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)
        }

        this.isTemplate = sourceObject.isTemplate
        this.visible = sourceObject.visible
    }

    public clone(includeNavigationProperties: boolean, includeCustomProperties: boolean, includeDataList: boolean, includeDynamicValues: boolean): GoAlarmDef {
        const newAlarmDef: GoAlarmDef = new GoAlarmDef(null)

        newAlarmDef.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newAlarmDef
    }
}

// #endregion

// #region IAlarmDefinitionsEditOptions

export interface IAlarmDefinitionsEditOptions {
    moduleName: Enums.SimaxModuleName
    configurationReferenceObject?: IReferenceType
    sendConfigurationIdActivity?: number

    referenceType: Enums.ReferenceType
    referenceObject: IReferenceType

    sendConfiguration?: (dataProvider: DataProvider, referenceObjects: IReferenceType[]) => JQueryPromise<ActionStatusOptions>
    onAlarmConfigurableSaved: (alarmConfigurable: IAlarmConfigurable) => void
}

export interface IAlarmDefinitionsBulkEditOptions extends IAlarmDefinitionsEditOptions {
    gridDataSource: any[]
    getEentityRequestMethod: (idEntity: number) => JQueryPromise<IAlarmConfigurable>
    getColumnsMethod: () => JQueryPromise<ColumnModel[]>
}

// #endregion

// #region IAlarmDefinitionsEdit

export interface IAlarmDefinitionsEdit {
    // show(columns?: DevExpress.ui.dxDataGridColumn[], source?: any[]): void
    // hide(): void

    // setDataSource(dataSource: IAlarmConfigurable): void
    // getDataSource(): IAlarmConfigurable

    // showLoader(): void
    // hideLoader(): void

    showSingleEdit(): void
    showBulkEdit(): void
}

// #endregion
